<template>
  <div>
    <div :class="{ active: measureActive, AngleMeasurement: AngleMeasurement }" @click="toggleMeasure">
      <img src="/static/images/Path@2x.png" alt="" />
    </div>
  </div>
</template>
<script>
import * as THREE from "three";
import Bus from '../../utils/bus.js'
import { mapState } from 'vuex'

import { CSS2DRenderer, CSS2DObject } from 'three/addons/renderers/CSS2DRenderer.js'
import { mapMutations } from 'vuex'

export default {
  data() {
    return {
      raycaster: new THREE.Raycaster(),
      mouse: new THREE.Vector2(),
      selectedPoints: [],
      points: [],
      point1: [],
      po: false,
      measureActive: false,
      AngleMeasurement: "AngleMeasurement",
      renderer: null,
      labelRenderer: null,
      distanceDisplay: null,
      earthLabel: null,
      count: 1,
      measure: false,
    };
  },
  computed:{
    ...mapState(["toolAngle"]),
  },
  watch:{
    toolAngle:{
      handler(news,old){
        this.measure= news
        if(!this.measure){
          this.measureActive=false
        }
    }
    }
  
  },
  methods: {
    ...mapMutations(["setLabelRenderer","setToolDistance","setToolAngle","setToolLabels"]),

    // 获取参数
    toggleMeasure() {
      this.setToolAngle(true)
      this.setToolDistance(false)

      this.setToolLabels(false)
      this.measureActive = !this.measureActive;
      const canvasContainer = this.renderer[0].domElement;
      if (this.measureActive) {
        canvasContainer.style.cursor = "crosshair";
        this.renderer[0].domElement.addEventListener(
          "click",
          this.onMouseClick
        );
      } else {
        canvasContainer.style.cursor = "auto";
      }
    },

    onMouseClick(event) {
      if(!this.measure)   return

      if (!this.measureActive) return;
      const canvasContainer = this.renderer[0].domElement;
      const rect = canvasContainer.getBoundingClientRect();

      this.mouse.x =
        ((event.clientX - rect.left) / canvasContainer.clientWidth) * 2 - 1;
      this.mouse.y =
        -((event.clientY - rect.top) / canvasContainer.clientHeight) * 2 + 1; // 遍历场景中的所有点，查找与鼠标位置最近的点

      this.raycaster.setFromCamera(this.mouse, this.renderer[1]);
      const intersects = this.raycaster.intersectObjects(
        this.$store.state.meshList,
        true
      );
      if (intersects.length > 0) {
        const point = intersects[0].point;
        const material = new THREE.MeshBasicMaterial({ color: "black" });
        const geometry = new THREE.SphereGeometry(2);
        const sphere = new THREE.Mesh(geometry, material);
        sphere.position.copy(point);

        this.selectedPoints.push(point);
        this.points.push(sphere); // 如果已经选择了三个点，就连接它们

        this.renderer[2].add(sphere);
        if (this.selectedPoints.length == 3) {
          this.point1.push(this.points);
          const lineMaterial = new THREE.LineBasicMaterial({ color: 0x0000ff, linewidth: 2  });
          const geometry = new THREE.BufferGeometry();
          const vertices = new Float32Array([
            this.selectedPoints[0].x,
            this.selectedPoints[0].y,
            this.selectedPoints[0].z,
            this.selectedPoints[1].x,
            this.selectedPoints[1].y,
            this.selectedPoints[1].z,
            this.selectedPoints[2].x,
            this.selectedPoints[2].y,
            this.selectedPoints[2].z,
          ]);
          // 在屏幕上显示点击位置的坐标
          var point1 = intersects[0].point;
          let vector = new THREE.Vector3(point1.x, point1.y, point1.z);
          vector.project(this.renderer[1]);

          geometry.setAttribute(
            "position",
            new THREE.BufferAttribute(vertices, 3)
          );
          const line = new THREE.Line(geometry, lineMaterial);
          this.renderer[2].add(line); // 计算角度

          const vectorA = new THREE.Vector3().subVectors(
            this.selectedPoints[1],
            this.selectedPoints[0]
          );

          const vectorB = new THREE.Vector3().subVectors(
            this.selectedPoints[1],
            this.selectedPoints[2]
          );

          const angleC = (vectorB.angleTo(vectorA) * 180) / Math.PI;

          this.distanceDisplay = document.createElement("div");
          this.distanceDisplay.innerText = `${angleC.toFixed(2) + "°"}`;
          this.distanceDisplay.id = `${this.count++}`;
          this.distanceDisplay.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
          this.distanceDisplay.style.borderRadius = "6px";
          this.distanceDisplay.style.color = "yellow";
          this.distanceDisplay.style.fontSize = "10px";
          this.distanceDisplay.style.pointerEvents = "auto";
          this.earthLabel = new CSS2DObject(this.distanceDisplay);
          this.earthLabel.position.set(1.5, 0, 0);
          // this.earthLabel.center.set(0, 1);
          // 添加点击事件监听器

          this.points[1].add(this.earthLabel);
          this.distanceDisplay.addEventListener("click", (event) => {
            // 在点击事件处理函数中执行需要的操作
            const ids = event.target.id - 1;

            const points1 = this.point1[ids];
            Bus.$emit("eventDIV", [event, line, points1]);
          });
          this.selectedPoints = [];
          this.points = [];
          const animate = () => {
            this.renderer[0].render(this.renderer[2], this.renderer[1]);
            this.labelRenderer.render(this.renderer[2], this.renderer[1]);
            requestAnimationFrame(animate);
          };
          animate();
        }
      }
    },
  },
  mounted() {
    this.renderer = this.$store.state.rendererRef;
    this.labelRenderer = new CSS2DRenderer();
    this.labelRenderer.setSize(window.innerWidth, window.innerHeight);
    this.labelRenderer.domElement.style.position = "absolute";
    this.labelRenderer.domElement.style.top = "0px";
    this.labelRenderer.domElement.style.zIndex = 0;
 
    this.labelRenderer.domElement.style.pointerEvents = "none";
    const add = document.getElementById("webgl");
    add.appendChild(this.labelRenderer.domElement);
    this.setLabelRenderer(this.labelRenderer);
    // Bus.$emit("eventDIVs", [ this.labelRenderer,this.earthLabel]);
  },
};
</script>
<style scoped lang="scss">
.AngleMeasurement {
  width: 35px;
  height: 35px;
  > img {
    width: 100%;
    height: 100%;
  }
}
</style>